// components/ProtectedRoute.js
import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import PasswordModal from "../components/PasswordModal";
import axios from "axios";
import { USER } from "../api/vsc";

const ProtectedRoute = ({ children, routeName }) => {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch user data
    const fetchUserData = async () => {
      try {
        const response = await axios.get(USER, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setData(response.data);

        // If org role, no password needed
        if (response.data.role === "org") {
          setIsAuthenticated(true);
        }
      } catch (err) {
        console.error("Failed to fetch user data", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleSuccess = () => {
    localStorage.setItem(`auth_${routeName}`, "true");
    setIsAuthenticated(true);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  // If authenticated (either by password or org role)
  if (isAuthenticated) {
    return children;
  }

  // For non-org users, show password modal
  if (!loading && data?.role !== "org") {
    return (
      <>
        <PasswordModal
          onClose={() => setShowModal(false)}
          onSuccess={handleSuccess}
          path={routeName}
        />
        {children}
      </>
    );
  }

  return null;
};

export default ProtectedRoute;
